const KM_PER_NAUTICAL_MILE = 1.852;
const KM_PER_MILE = 1.609344;

export const isMarineRouteMode = (mode) => {
  const normalized = String(mode || "").trim().toLowerCase();
  return normalized === "coastal" || normalized === "international" || normalized === "sea";
};

export const getPreferredDistanceUnit = (mode, preferences = {}) => {
  if (isMarineRouteMode(mode)) return "nm";
  return preferences?.distance_unit === "mi" ? "mi" : "km";
};

export const getPreferredSpeedUnit = (mode, preferences = {}) => {
  if (isMarineRouteMode(mode)) return "kn";
  return preferences?.speed_unit === "mph" ? "mph" : "kmh";
};

export const formatDistanceKm = (km, mode, preferences = {}, options = {}) => {
  const value = Number(km);
  if (!Number.isFinite(value)) return "—";

  const unit = getPreferredDistanceUnit(mode, preferences);
  const digits = options.digits ?? (Math.abs(value) < 10 ? 1 : 0);
  if (unit === "nm") return `${(value / KM_PER_NAUTICAL_MILE).toFixed(options.digits ?? 1)} N.M.`;
  if (unit === "mi") return `${(value / KM_PER_MILE).toFixed(digits)} mi`;
  return `${value.toFixed(digits)} km`;
};

export const formatSpeedKmh = (kmh, mode, preferences = {}, options = {}) => {
  const value = Number(kmh);
  if (!Number.isFinite(value)) return "—";

  const unit = getPreferredSpeedUnit(mode, preferences);
  const digits = options.digits ?? 1;
  if (unit === "kn") return `${(value / KM_PER_NAUTICAL_MILE).toFixed(digits)} kt`;
  if (unit === "mph") return `${(value / KM_PER_MILE).toFixed(digits)} mph`;
  return `${value.toFixed(digits)} km/h`;
};

export const formatSpeedKnots = (knots, mode, preferences = {}, options = {}) => {
  const value = Number(knots);
  if (!Number.isFinite(value)) return "—";
  return formatSpeedKmh(value * KM_PER_NAUTICAL_MILE, mode, preferences, options);
};
